export const RESOURCES_TABS_TITLES = {
  Blog: "Blog",
  Guides: "Guides",
  Professionals: "Professionals",
  Candidates: "Declared Candidates",
};

export const RESOURCES_TABS = [
  {
    id: 1,
    title: RESOURCES_TABS_TITLES.Blog,
    description: "Blog posts on fundraising, campaigning, and more.",
    link: "/blogs",
    iconSrc: "/images/icons/header/book-open-text.svg",
  },
  {
    id: 2,
    title: RESOURCES_TABS_TITLES.Guides,
    description: "Detailed guides to help your campaigns thrive.",
    link: "/guides",
    iconSrc: "/images/icons/header/notebook.svg",
  },
  {
    id: 5,
    title: "User Guide",
    description: "Learn how to use every feature of ReachThePeople.ai.",
    link: "/resources/user-guide",
    iconSrc: "/images/icons/header/notebook.svg",
  },
  {
    id: 3,
    title: RESOURCES_TABS_TITLES.Professionals,
    description:
      "Browse vetted campaign experts for strategy, outreach, and engagement.",
    link: "/campaign-professionals",
    iconSrc: "/images/icons/header/users.svg",
    card: {
      imgSrc: "/images/professionals/hero.webp",
      title: "Find Your Campaign Professional",
      description:
        "Browse vetted professionals skilled in election strategy, outreach, and voter engagement.",
      buttonLabel: "Find professional",
      buttonLink: "/campaign-professionals",
    },
  },
  {
    id: 4,
    title: RESOURCES_TABS_TITLES.Candidates,
    description:
      "Explore verified candidates, their goals, affiliations, and vision.",
    link: "/declared-candidates",
    iconSrc: "/images/icons/header/candidates.svg",
    card: {
      imgSrc: "/images/declared-candidates/hero.jpg",
      title: "Find a Declared Candidate",
      description:
        "Browse verified candidates running for office. Learn about their goals, affiliations, and vision for the future.",
      buttonLabel: "Find candidate",
      buttonLink: "/declared-candidates",
    },
  },
];
